import type { InventoryMapObjectData, InventoryMapViewportType } from '@/widgets'
import InventObjectLine from './InventObjectLine.ts'
import InventObjectPolygon from './InventObjectPolygon.ts'
import InventObjectPoint from './InventObjectPoint.ts'

export class InventObjectCreator {
  /**
   * Вид геометрии берём из `objectData.geometry.type` (GeoJSON самоописывающийся),
   * а не из словаря типов — новый контракт `/objects/map` отдаёт в `types[id].figure`
   * числовые `figure_id`/`line_type_id`, а не строку `geom_type`.
   */
  static create(objectData: InventoryMapObjectData, objectType: InventoryMapViewportType) {
    switch (objectData.geometry.type) {
      case 'LineString':
        return new InventObjectLine(objectData, objectType)
      case 'Polygon':
        return new InventObjectPolygon(objectData, objectType)
      default:
        return new InventObjectPoint(objectData, objectType)
    }
  }
}
